import PropTypes from 'prop-types';

export const filtersShape = PropTypes.shape({
  'bathrooms[]': PropTypes.arrayOf(PropTypes.string),
  bed: PropTypes.string,
  budget: PropTypes.string,
  'features[]': PropTypes.arrayOf(PropTypes.string),
  flexibleMoveIn: PropTypes.number,
  flexibleMoveOut: PropTypes.number,
  instantBooking: 0,
  'move-in': PropTypes.string,
  'move-out': PropTypes.string,
  page: PropTypes.number,
  poi: PropTypes.string,
  sortBy: PropTypes.string,
  'topology[]': PropTypes.arrayOf(PropTypes.string),
  'type[]': PropTypes.arrayOf(PropTypes.string),
  verified: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isBestChoice: PropTypes.number,
  plan: PropTypes.string,
  'areaId[]': PropTypes.arrayOf(PropTypes.string),
  'rentalType[]': PropTypes.arrayOf(PropTypes.string),
  noDeposit: PropTypes.number,
  moveOutFrom: PropTypes.string,
  moveOutTo: PropTypes.string,
  moveInFrom: PropTypes.string,
  moveInTo: PropTypes.string
});
